import {
    COMMUNICATIONS_ERROR,
    FETCH_COMMUNICATIONS_REQUEST,
    GET_COMMENTS,
    GET_COMMUNICATION,
    SET_COMMUNICATION_STATUS,
    SET_SELECTED_COMMUNICATION,
    GET_COMMUNICATION_LIST,
    GET_COMMENT_TEXT,
    IS_PARTNER_CONNECTED,
    GET_EMPTY_COMMUNICATION,
    GET_SELECTED_COMMUNICATION_PARTNER,
    STORE_ADDED_COMMUNICATION,
    STORE_ADDED_REQUEST,
    UPDATE_STORED_COMMUNICATIONS,
    UPDATE_STORED_REQUESTS,
    SET_MENTIONABLE_COMMENT_USERS,
    SET_COMMUNICATION_PARTNERS,
    SELECT_NEW_COMMUNICATION,
    SET_INCLUDE_CLOSED_COMMUNICATIONS,
    SET_COMMUNICATION_ACTIVITY,
} from '../ActionTypes';

const initialState = {
    allCommunications: [],
    communicationActivity: [],
    communication: [],
    comments: [],
    selectedCommunication: {},
    loading: true,
    error: '',
    communicationStatus: true,
    includeClosedCommunications: false,
    commentText: '',
    isPartnerConnected: false,
    emptyCommunication: {},
    selectedPartner: {},
    storedCommunications: [],
    storedRequests: [],
    isPartnerSelected: false,
    mentionableCommentUsers: [],
    communicationTypes: [],
    communicationPartners: [],
    pimsFieldRequiredBy: [`CONVERSION`],
    practiceContactFieldRequiredBy: [`CONVERSION`],
    dateFieldsRequiredBy: [`CONVERSION`],
    authorizedFieldRequiredBy: [`CONVERSION`],
};

const communicationReduction = (state = initialState, action) => {
    switch (action.type) {
        case SELECT_NEW_COMMUNICATION:
            return {
                ...state,
                allCommunications: action.payload,
                // selectedCommunication: action.payload[0],
            };
        case SET_COMMUNICATION_PARTNERS:
            return {
                ...state,
                communicationPartners: action.payload,
            };
        case FETCH_COMMUNICATIONS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case COMMUNICATIONS_ERROR:
            return {
                ...state,
                communications: [],
                loading: false,
                error: action.payload,
            };
        case GET_COMMUNICATION:
            return {
                ...state,
                communication: action.payload,
            };
        case GET_COMMUNICATION_LIST:
            return {
                ...state,
                allCommunications: action.payload,
                //selectedCommunication: selectedCommunication
            };
        case GET_COMMENTS:
            return {
                ...state,
                comments: action.payload,
            };
        case GET_COMMENT_TEXT:
            return {
                ...state,
                commentText: action.payload,
            };
        case SET_SELECTED_COMMUNICATION:
            return {
                ...state,
                selectedCommunication: action.payload,
            };
        case SET_COMMUNICATION_STATUS:
            return {
                ...state,
                communicationStatus: action.payload,
            };
        case IS_PARTNER_CONNECTED:
            return {
                ...state,
                isPartnerConnected: action.payload,
            };
        case GET_EMPTY_COMMUNICATION:
            return {
                ...state,
                emptyCommunication: action.payload.communication,
                communicationTypes: action.payload.communicationTypes,
                //communicationPartners: action.payload.partners,
            };
        case GET_SELECTED_COMMUNICATION_PARTNER:
            return {
                ...state,
                selectedPartner: action.payload,
            };
        case STORE_ADDED_COMMUNICATION:
            return {
                ...state,
                storedCommunications: [
                    ...state.storedCommunications,
                    action.payload,
                ],
            };
        case STORE_ADDED_REQUEST:
            return {
                ...state,
                storedRequests: [...state.storedRequests, action.payload],
            };
        case UPDATE_STORED_COMMUNICATIONS:
            return {
                ...state,
                storedCommunications: action.payload,
            };
        case UPDATE_STORED_REQUESTS:
            return {
                ...state,
                storedRequests: action.payload,
            };
        case SET_MENTIONABLE_COMMENT_USERS:
            return {
                ...state,
                mentionableCommentUsers: action.payload,
            };
        case SET_INCLUDE_CLOSED_COMMUNICATIONS:
            return {
                ...state,
                includeClosedCommunications: action.payload,
            };
        case SET_COMMUNICATION_ACTIVITY:
            return {
                ...state,
                communicationActivity: action.payload,
            };
        default:
            return state;
    }
};

export default communicationReduction;
